import {
  isExperimentEnabled,
  trackEvent
} from 'views/assets/scripts/optimizely'

import {
  PDP_COMPACT_PRESCRIPTION_TYPES_COM,
  PDP_COMPACT_PRESCRIPTION_TYPES_AT_IT
} from 'shared/experiments/consts'
import store from 'shared/store'
import { TENANT_COM, TENANT_IT, TENANT_AT } from 'shared/consts/tenants'

const ALLOWED = {
  [PDP_COMPACT_PRESCRIPTION_TYPES_COM]: [TENANT_COM],
  [PDP_COMPACT_PRESCRIPTION_TYPES_AT_IT]: [TENANT_IT, TENANT_AT]
}
const SUFFIX = {
  [PDP_COMPACT_PRESCRIPTION_TYPES_COM]: 'COM',
  [PDP_COMPACT_PRESCRIPTION_TYPES_AT_IT]: 'AT & IT'
}

export default () => {
  if (!Object.keys(ALLOWED).some(isExperimentEnabled)) {
    return
  }

  const experiment = isExperimentEnabled(PDP_COMPACT_PRESCRIPTION_TYPES_COM)
    ? PDP_COMPACT_PRESCRIPTION_TYPES_COM
    : PDP_COMPACT_PRESCRIPTION_TYPES_AT_IT
  const {
    publicConfig: { tenant }
  } = store.getPublicRuntimeConfig()

  if (!ALLOWED[experiment].includes(tenant)) {
    return
  }

  const suffix = SUFFIX[experiment]
  const A2C_CLICK_EVENT_NAME = `PDP COMPACT PRESCRIPTION TYPES - Add to cart click (${suffix})`
  const VARIANT_CLICK_EVENT_NAME = `PDP COMPACT PRESCRIPTION TYPES - Variant click (${suffix})`
  const WISHLIST_CLICK_EVENT_NAME = `PDP COMPACT PRESCRIPTION TYPES - Add to wishlist click (${suffix})`

  const add2CartForm = document.querySelector(
    '[data-clientside-hook~="add2CartForm"]'
  )

  if (add2CartForm) {
    add2CartForm.addEventListener('submit', () => {
      trackEvent(A2C_CLICK_EVENT_NAME)
    })
  }

  document.addEventListener('click', ({ target }) => {
    const variantLink = target?.closest(
      '[data-clientside-hook~="productVariant__link"]'
    )

    if (variantLink) {
      trackEvent(VARIANT_CLICK_EVENT_NAME)
    }
  })

  const wishListButton = document.querySelector(
    '[data-clientside-hook~="wishListButton"]'
  )
  if (wishListButton) {
    wishListButton.addEventListener('click', () => {
      trackEvent(WISHLIST_CLICK_EVENT_NAME)
    })
  }
}
